'use client';

import React, { type PropsWithChildren, Component } from 'react';
import { SirenIcon } from 'lucide-react';
import { Button } from '@spellix/ui';

export class ErrorBoundary extends Component<PropsWithChildren> {
  state: { hasError: boolean };

  constructor(props: PropsWithChildren) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error) {
    return { hasError: true };
  }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error({ error, errorInfo });
  }

  render() {
    const { children } = this.props;

    if (this.state.hasError) {
      return (
        <div className="flex flex-col gap-4 h-screen w-screen items-center justify-center">
          <div className="flex flex-col items-center justify-center rounded-full p-4">
            <SirenIcon className="w-16 h-16 text-red-500 animate-pulse" />
          </div>

          <h2 className="text-2xl font-bold">Oops, there is an error!</h2>
          <Button
            onClick={() => {
              this.setState({ hasError: false });
            }}
          >
            Try again?
          </Button>
        </div>
      );
    }

    return <>{children}</>;
  }
}
